import React from 'react';
import { Text, TextTypography } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '@wix/yoshi-flow-editor';

import { classes, st } from './EmptyState.st.css';

type EmptyStateProps = {
  className?: string;
  children?: React.ReactNode;
};

const EmptyState: React.FC<EmptyStateProps> = ({ className, children }) => {
  const { t } = useTranslation();

  return (
    <div className={st(classes.root, className)}>
      {children ?? (
        <>
          <Text
            className={classes.title}
            typography={TextTypography.smallTitle}
            tagName="h3"
          >
            {t('menu_olo.emptyState.title')}
          </Text>
          <Text tagName="p">{t('menu_olo.emptyState.subTitle')}</Text>
        </>
      )}
    </div>
  );
};

export default EmptyState;
